/**
 * @generated SignedSource<<761952d5c95a7723ef972c26da3c8e5d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type topicSeoTopic$data = {
  readonly description: {
    readonly text: string | null | undefined;
  } | null | undefined;
  readonly entityId: string;
  readonly entityUuid: string;
  readonly metaDescription: string | null | undefined;
  readonly name: string;
  readonly sponsor: {
    readonly name: string | null | undefined;
  } | null | undefined;
  readonly urlAlias: string;
  readonly " $fragmentSpreads": FragmentRefs<"hooksUseDeepLinkTagsBase" | "hooksUseDynamicMetaTags">;
  readonly " $fragmentType": "topicSeoTopic";
};
export type topicSeoTopic$key = {
  readonly " $data"?: topicSeoTopic$data;
  readonly " $fragmentSpreads": FragmentRefs<"topicSeoTopic">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "topicSeoTopic",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "entityUuid",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "entityId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Sponsor",
      "kind": "LinkedField",
      "name": "sponsor",
      "plural": false,
      "selections": [
        (v0/*: any*/)
      ],
      "storageKey": null
    },
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "FormattedValue",
      "kind": "LinkedField",
      "name": "description",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "text",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "urlAlias",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "metaDescription",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "hooksUseDeepLinkTagsBase"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "hooksUseDynamicMetaTags"
    }
  ],
  "type": "Topic",
  "abstractKey": null
};
})();

(node as any).hash = "6840d27b1872723c2dcc73518153a12d";

export default node;
